let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "客户编号",
    props: "custNo",
    minWidth: 200,
  },
  {
    label: "客户手机号",
    props: "mobile",
    minWidth: 200,
  },
  // {
  //     label: '认证状态',
  //     props: 'registerType',
  //     minWidth: 200,
  // },
  {
    label: "注册渠道",
    props: "registerSource",
    minWidth: 200,
  },
  {
    label: "账号类型",
    props: "custType",
    minWidth: 200,
  },
  {
    label: "注册时间",
    props: "registerTime",
    minWidth: 200,
  },
  // 23-06-02添加最近登陆时间
  {
    label: "最近登录时间",
    props: "loginTime",
    minWidth: 200,
  },
  {
    label: "最近登录来源",
    props: "loginSource",
    minWidth: 200,
  },
  {
    label: "最近充电时间",
    props: "latestChargeDate",
    minWidth: 200,
  },
  {
    label: "累计充电次数",
    props: "totalChargeTimes",
    minWidth: 120,
  },
  {
    label: "累计充电量（kW·h）",
    props: "totalCount",
    minWidth: 200,
  },
  {
    label: "累计收益（元）",
    props: "totalFee",
    minWidth: 200,
  },
  {
    label: "绑定充电桩",
    props: "pileCodes",
    minWidth: 200,
  },
];

// 列表展示项
pageConfig.dialogListColumns = [
  {
    label: "标签名称",
    props: "configName",
    minWidth: 200,
  },
  {
    label: "创建人",
    props: "createdByName",
    minWidth: 300,
    tooltip: true,
  },
  {
    label: "标签数量",
    props: "configDisp",
    minWidth: 200,
  },
];
pageConfig.activateListColumns = [
  {
    label: "购买订单编号",
    props: "configName",
    minWidth: 200,
  },
  {
    label: "用户手机号",
    props: "createdByName",
    minWidth: 300,
    tooltip: true,
  },
  {
    label: "购买类型",
    props: "configDisp",
    minWidth: 200,
  },
  {
    label: "购买名称",
    props: "configDisp",
    minWidth: 200,
  },
  {
    label: "购买内容",
    props: "configDisp",
    minWidth: 200,
  },
  {
    label: "购买金额",
    props: "configDisp",
    minWidth: 200,
  },
  {
    label: "购买时间",
    props: "configDisp",
    minWidth: 200,
  },
  {
    label: "支付方式",
    props: "configDisp",
    minWidth: 200,
  },
  {
    label: "交易流水号",
    props: "configDisp",
    minWidth: 200,
  },
];
// 列表展示项
pageConfig.custDetailColumns = [
  {
    label: "操作时间",
    props: "lastModifiedWhen",
    minWidth: 200,
  },
  {
    label: "充值金额（元）",
    props: "inExpAmount",
    minWidth: 200,
    tooltip: true,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.operateType == "01") {
        return row.inExpAmount;
      } else {
        return "";
      }
    },
  },
  {
    label: "退款金额（元）",
    props: "inExpAmount",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.operateType == "07") {
        return row.inExpAmount;
      } else {
        return "";
      }
    },
  },
  {
    label: "账户剩余金额（元）",
    props: "changeFreeBal",
    minWidth: 200,
  },
  {
    label: "操作人",
    props: "lastModifiedByName",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark",
    minWidth: 200,
  },
];

// 列表展示项
pageConfig.custkWhDetailColumns = [
  {
    label: "度电",
    props: "chargeValue",
    minWidth: 200,
  },
  {
    label: "账户剩余度电",
    props: "chargeBalanceValue",
    minWidth: 200,
    // tooltip:true,
    // formatter: function formatter(row, column, cellValue, index) {
    //     // 做判断
    //     if (row.operateType == '01') {
    //         return row.inExpAmount;
    //     }
    //     else {
    //         return ''
    //     }
    // }
  },
  {
    label: "操作人",
    props: "createdByName",
    minWidth: 200,
    // formatter: function formatter(row, column, cellValue, index) {
    //     // 做判断
    //     if (row.operateType == '07') {
    //         return row.inExpAmount;
    //     }
    //     else {
    //         return ''
    //     }
    // }
  },
  {
    label: "操作时间",
    props: "createdWhen",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark",
    minWidth: 200,
  },
];

// 车辆信息列表
pageConfig.chargeListColumns = [
  {
    label: "充电订单编号",
    props: "orderNo",
    minWidth: 200,
  },
  {
    label: "业务归属",
    props: "belongTo",
    minWidth: 150,
  },
  {
    label: "订单状态",
    props: "payStatusName",
    minWidth: 150,
  },
  {
    label: "充电用户",
    props: "custPhone",
    minWidth: 180,
  },
  {
    label: "订单属性",
    props: "orderPropertyName",
    minWidth: 150,
  },
  {
    label: "启动方式",
    props: "startWayName",
    minWidth: 200,
  },
  {
    label: "开始时间",
    props: "beginTime",
    minWidth: 200,
  },
  {
    label: "结束方式",
    props: "endWayName",
    minWidth: 200,
  },
  {
    label: "结束时间",
    props: "endTime",
    minWidth: 200,
  },
  {
    label: "充电电量（kW·h）",
    props: "chargeVal",
    minWidth: 150,
  },
  {
    label: "充电时长",
    props: "chargeHourMinute",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark ",
    minWidth: 200,
  },
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "用户信息管理",
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
};
// 列表-表格属性
pageConfig.pileTableConfig = {
  showSelection: false,
  showIndex: false,
};

// dialog列表-表格属性
pageConfig.dialogTableConfig = {
  showSelection: false,
  showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

// 列表-分页参数
pageConfig.detailPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};
// 车辆信息 - 分页参数
pageConfig.carPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};
// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "pileModelDetail",
};

// 路由
pageConfig.listRouter = "custManageList";

pageConfig.custDeatilRouter = "custDetail";

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "用户信息管理",
    router: "custManageList",
  },
  {
    type: "title",
    name: "客户详情",
  },
];

pageConfig.formRules = {
  pileTypeName: [
    {
      required: true,
      message: "请填写充电桩型号名称",
      trigger: "blur",
    },
  ],
};

pageConfig.labelFormRules = {
  configName: [
    {
      required: true,
      message: "请填写标签名称",
      trigger: "blur",
    },
  ],
  configVal: [
    {
      required: true,
      message: "请填写编号",
      trigger: "blur",
    },
  ],
};

pageConfig.dealerFormRules = {
  dealerNo: [
    {
      required: true,
      message: "请填写运营商全称",
      trigger: "blur",
    },
  ],
  mobile: [
    {
      required: true,
      message: "请填写客户手机号",
      trigger: "blur",
    },
    {
      pattern:
        /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
      message: "手机号填写错误",
      trigger: "blur",
    },
  ],
};

pageConfig.selectFormRules = {
  remark: [
    {
      required: true,
      message: "请填写备注",
      trigger: "blur",
    },
  ],
  chargeValue: [
    {
      required: true,
      message: "请输入充值度电",
      trigger: "blur",
    },
  ],
};

pageConfig.remarkFormRules = {
  remark: [
    {
      required: true,
      message: "请填写备注",
      trigger: "blur",
    },
  ],
};

export default pageConfig;
